module.exports = __webpack_public_path__ + "img/hardwareOpen3.4ef974ba.png";